import React, { FC, MouseEventHandler, useRef, useState } from 'react';
import { Placement } from '@popperjs/core';
import { JourneyMenu, JourneyMenuPropsInterface } from 'src/common/JourneyMenu';
import { DeleteRegularIcon } from 'src/monet/icons';
import { Nullable } from 'src/types/nullable.type';

import { functionNoop } from 'src/utils/function/noop';
import { DashboardHomeDeleteConfirmPanel } from 'src/dashboard/home/delete-confirm-panel';

interface DashboardHomeOrganizationTemplateOptionsProps {
  onOpen: () => void;
  onClose: () => void;
  onDelete: () => void;
  nestedMenuPlacement: JourneyMenuPropsInterface['placement'];
  renderMenuOrigin: (onClick: any) => any;
}

export type DashboardHomeOrganizationTemplateOptionsTypes = 'delete';

export const DashboardHomeOrganizationTemplateOptions: FC<DashboardHomeOrganizationTemplateOptionsProps> = ({
  onOpen,
  onClose,
  onDelete,
  nestedMenuPlacement,
  renderMenuOrigin,
}) => {
  const [activePanel, setActivePanel] = useState<Nullable<DashboardHomeOrganizationTemplateOptionsTypes>>(null);

  const settingsMenuOpenRef = useRef(functionNoop);
  const settingsMenuCloseRef = useRef(functionNoop);

  const deleteMenuOpenRef = useRef(functionNoop);
  const deleteMenuCloseRef = useRef(functionNoop);

  const menuItemClasses = 'text-bedrock-p text-bedrock-black text-left';

  const onMenuClicked: MouseEventHandler = () => {
    settingsMenuOpenRef.current();
  };

  const onBack = () => {
    setActivePanel(null);
    deleteMenuCloseRef.current();
    setTimeout(onMenuClicked, 50);
  };

  const onClosePanel = () => {
    setActivePanel(null);
    onClose();
  };

  const onDeleteConfirmed = () => {
    onDelete();
    onClosePanel();
  };

  if (activePanel === 'delete') {
    return (
      <DashboardHomeDeleteConfirmPanel
        renderOrigin={() => renderMenuOrigin(onMenuClicked)}
        placement={nestedMenuPlacement || 'bottom-start'}
        openRef={deleteMenuOpenRef}
        closeRef={deleteMenuCloseRef}
        content='Deleting this Template is an irreversible action'
        confirmText='Yes, delete'
        denyText='No, keep'
        onOpen={onOpen}
        onClose={onClosePanel}
        onConfirm={onDeleteConfirmed}
        onDeny={onClosePanel}
        onBack={onBack}
      />
    );
  }

  return (
    <JourneyMenu
      placement='bottom-start'
      openRef={settingsMenuOpenRef}
      closeRef={settingsMenuCloseRef}
      onOpen={onOpen}
      onClose={onClose}
      renderOrigin={() => renderMenuOrigin(onMenuClicked)}
    >
      <JourneyMenu.Item className={menuItemClasses} onClick={() => setActivePanel('delete')}>
        <div className='flex items-center space-x-sm'>
          <DeleteRegularIcon />
          <span className='text-bedrock-p text-bedrock-black'>Delete</span>
        </div>
      </JourneyMenu.Item>
    </JourneyMenu>
  );
};
